import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import ActionGet from '../../store/action/AccessModule/Fetch'
import ActionEdit from '../../store/action/AccessModule/Edit'
import ActionGetPrevilages from '../../store/action/Previlage/FetchAll'
import "../../source/util.css"
import Swal from "sweetalert2";

class Page extends Component{
    constructor(props){
        super(props)

        this.state = {
            title: "Access Modules",
            previlage: null,
            columns:[
               // { className : "col-sm-2", field: "menu-id", caption: "Id", allowSearch: true },
               // { className : "col-sm-2", field: "menu-parent-id", caption: "Parent", allowSearch: true },
                { className : "col-sm-6", field: "menu-name", caption: "Name", allowSearch: true },
                { className : "col-sm-2", field: "access", caption: "Access", allowSearch: true },
                { className : "col-sm-2", field: "action-id", caption: "Action", allowSearch: true },
            ],
            items: fromJS([]),
            accessmodulestime : new Date().getTime(),
            needRefresh: true,
            errors: fromJS({}),
            valCheck: false,
            numbCheck: 1,
        };
    
        this.handleSearch = this.handleSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

    }

    componentDidMount(){
        this.props.actionGetPrevilages();
    }

    static getDerivedStateFromProps(props, state){
        if(props.accessmodules != null && state.needRefresh){
            if(props.accessmodules.get('data') != null){
                if(state.accessmodulestime !== props.accessmodulestime){
                    var propitems = props.accessmodules.get('data');
                    return { 
                        items: propitems, 
                        needRefresh: false, 
                        accessmodulestime: props.accessmodulestime  
                    }
                }
                
            }
        }
        return null;
    }

    async handleSubmit()    {
        var data = [];
        const {items} = this.state;
        // eslint-disable-next-line array-callback-return
        items.map((value) => {
            data.push({
                "menu-id": value.get('menu-id'),
                "access": value.get('access'),
                "action-id": value.get('action-id')
            })
        });
        if(this.state.previlage == "null" || this.state.previlage == null || 
        this.state.previlage == "" || this.state.previlage == undefined){
            toast.error('Previllage cannot be empty', toast.POSITION.TOP_RIGHT);
            return false
        }
        
        var obj = {
            "query-result": {
                "privilege-id": this.state.previlage,
                "data": data
            }
        };
        var response = await this.props.actionEdit(obj);

        if(response.ok){
            toast.success('Save Success!', toast.POSITION.TOP_RIGHT);     
        }else{
            toast.error('Save Failed', toast.POSITION.TOP_RIGHT);
        }

        const {previlage} = this.state;
        this.setState({needRefresh: true});
        this.props.actionGet(previlage);
    }



    handleSearch(){
        const {previlage} = this.state;
        this.setState({ items: fromJS([]) })
        this.setState({needRefresh: true});
        this.props.actionGet(previlage);
    }

    handleChange(){
        // eslint-disable-next-line no-restricted-globals
        var value = event.target.value;

        this.setState({
            previlage: value
        });
    }
    handleCancelForm(refresh){
        if(refresh){
            this.props.actionGet();
        }
    }

    handlePageChanged = (value) => {
        this.props.actionGet(value);
    }

    handleChangeItem = (index, type) => {
        // eslint-disable-next-line no-restricted-globals
        const value = event.target.value;
        var oldItems = this.state.items;
        var item =oldItems.get(index);
        if (type == 'access') {
            if(item != null){
                if(value === "true"){
                    item = item.set('access', true );
                }else{
                    item = item.set('access',false);
                }
            }
            oldItems = oldItems.set(index, item);
            this.setState({items: oldItems})
        } else {
            item = item.set('action-id', Number(value) );
            oldItems = oldItems.set(index, item);
            this.setState({items: oldItems})
        }
    }



    async handleRemoveClicked(value){
        var body = {
            "data":{
                "menu-id":value.get('menu-id')
            }
        };
        var temp = await this.props.actionDelete(body);
        if(temp.ok){    
            Swal.fire("Deleted!", "Data has been deleted.", "success");
            toast.success('Delete '+ value.get('menu-name') +' Success!', toast.POSITION.TOP_RIGHT)
            this.props.actionGet();
        }else{
            Swal.fire("Failed!", "Failed to delete data.", "error");
            toast.error('Delete '+ value.get('menu-name') +' Failed!', toast.POSITION.TOP_RIGHT)
        }
    }

    render(){
        const {title} = this.state;
        var options = fromJS([]);
        if(this.props.previlagesall != null){
            options = this.props.previlagesall;  
        }

        return (    
            <div className="clearfix">
                <div className="card-noborder">
                    <h4>
                        { title }
                    </h4>
                </div>

                <div className="body">
                    <div className="card border">
                        <div className="body">
                            <div className="row no-margin-bottom">
                                <span className="col-sm-2">Privilege</span>
                                <div className="col-sm-10">
                                    <select className="form-control" 
                                    field='previlage'
                                    onChange={(field, value) => this.handleChange(field,value)}
                                    >
                                        <option>select</option>
                                        {
                                            options.map((value) => {
                                                return(
                                                    <option value={ value.get('privilege-id') } > { value.get('privilege-name') }</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="row no-margin-bottom">
                                <span className="col-sm-2"></span>
                                <div className="col-sm-2 no-margin-bottom">
                                    <button type="button"
                                        className="btn btn-wide btn-primary"
                                        value="Login"
                                        onClick={this.handleSearch}>
                                        <i className="material-icons">search</i> Search
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="card no-margin-bottom">
                    <div className="body">
                    { this.populateGrid() }
                    </div>
                    </div>
                </div>

                
            </div>
        );
    }


    populateGrid(){

        const { columns,items } = this.state;
        // const items = (this.props.accessmodules.get('data') != null ? this.props.accessmodules.get('data') : fromJS([]));
        return(
            <table className="table table-bordered table-responsive table-striped">
                <thead>
                <tr>
                    {
                        columns.map((col) => {
                            return <th key={col.caption} className={ col.className }> {col.caption} </th>
                        })
                    }
                </tr>
                </thead>
                <tbody>
                    {
                        items.map((item, index) => {
                            

                            return(
                                <tr key={index}>
                                    {   
                                        // eslint-disable-next-line array-callback-return
                                        columns.map((col) => {

                                            var value = 'false';

                                            if(item.get(col.field)){
                                                value = 'true';
                                            }

                                            var val = 1;
                                            if(item.get('action-id')){
                                                val = item.get('action-id');
                                            }

                                            if(col.field === 'access'){ return (
                                                    <td key={col.field} className={ col.className }> 
                                                        <select className="form-control" value={ value }
                                                        seleted ={ item.get(col.field) }
                                                        onChange={ ()=>this.handleChangeItem(index, "access") }
                                                        >
                                                            <option value='true'>true</option>
                                                            <option value='false'>false</option>
                                                        </select>
                                                    </td> 
                                                )
                                            } else if (col.field === "action-id") {
                                                let data_menu_id = item.get('menu-id');
                                                if (data_menu_id == 1) {
                                                    return (
                                                        <td key={col.field} className={`${col.className} text-center`}>
                                                            <select className="form-control" value={ val }
                                                                    seleted ={ item.get('action-id') }
                                                                    onChange={ ()=>this.handleChangeItem(index, "prevl") }
                                                            >
                                                                <option value="1">No Action</option>
                                                                <option value="2">Approver</option>
                                                                <option value="3">Show all division</option>
                                                                <option value="4">Approver and show all division</option>
                                                                <option value="5">Restrict By Sender</option>
                                                                <option value="6">Approver and Restrict By Sender</option>
                                                            </select>
                                                        </td>
                                                    )
                                                } else if ( data_menu_id == 30 || data_menu_id == 31 || data_menu_id == 53) {
                                                    return (
                                                        <td key={col.field} className={`${col.className} text-center`}>
                                                            <select className="form-control" value={val}
                                                                    seleted={item.get('action-id')}
                                                                    onChange={() => this.handleChangeItem(index, "prevl")}
                                                            >
                                                                <option value="1">No Action</option>
                                                                <option value="3">Show all division</option>
                                                            </select>
                                                        </td>
                                                    )
                                                }else if ( data_menu_id == 43 || data_menu_id == 52) {
                                                    return (
                                                        <td key={col.field} className={`${col.className} text-center`}>
                                                            <select className="form-control" value={val}
                                                                    seleted={item.get('action-id')}
                                                                    onChange={() => this.handleChangeItem(index, "prevl")}
                                                            >
                                                                <option value="1">No Action</option>
                                                                <option value="5">Restrict By Sender</option>
                                                            </select>
                                                        </td>
                                                    )
                                                }else if(data_menu_id == 29 || data_menu_id == 49 || data_menu_id == 51 || data_menu_id == 53){
                                                    return (
                                                        <td key={col.field} className={`${col.className} text-center`}>
                                                            <select className="form-control" value={val}
                                                                    seleted={item.get('action-id')}
                                                                    onChange={() => this.handleChangeItem(index, "prevl")}
                                                            >
                                                                <option value="1">No Action</option>
                                                                <option value="3">Show all division</option>
                                                                <option value="5">Restrict By Sender</option>
                                                            </select>
                                                        </td>
                                                    )
                                                // } else if(data_menu_id == 2 || data_menu_id == 3 || data_menu_id ==36 || data_menu_id ==19 || data_menu_id ==39){
                                                } else if(data_menu_id == 2 || data_menu_id == 3 || data_menu_id == 4 || data_menu_id == 5 || data_menu_id ==6 || data_menu_id ==7 || data_menu_id ==36 || data_menu_id ==19 || data_menu_id ==39){
                                                    return (
                                                        <td key={col.field} className={`${col.className} text-center`}>
                                                            <select className="form-control" value={ val }
                                                                    seleted ={ item.get('action-id') }
                                                                    onChange={ ()=>this.handleChangeItem(index, "prevl") }
                                                            >
                                                                <option value="1">No Action</option>
                                                                <option value="5">Restrict By Sender</option>
                                                            </select>
                                                        </td>
                                                    )
                                                } else if(data_menu_id == 44 || data_menu_id == 45 || data_menu_id == 46 || data_menu_id == 50){
                                                    return (
                                                        <td key={col.field} className={`${col.className} text-center`}>
                                                            <select className="form-control" value={ val }
                                                                    seleted ={ item.get('action-id') }
                                                                    onChange={ ()=>this.handleChangeItem(index, "prevl") }
                                                            >
                                                                <option value="1">No Action</option>
                                                                <option value="5">Restrict By Sender</option>
                                                            </select>
                                                        </td>
                                                    )
                                                }else{
                                                    return (<td></td>)
                                                }



                                            } else{
                                                return <td key={col.field} className={ col.className }> { item.get(col.field) } </td>
                                            }
                                        })
                                    }
                                </tr>
                            )
                        })
                    }
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan="4">
                            <button type="button"
                                className="btn btn-wide btn-success"
                                value="Login"
                                onClick={this.handleSubmit}>
                                Save
                            </button>
                        </td>
                    </tr>
                </tfoot>
            </table>
        )
    }
}


export default connect(
  (state) => {
      return {
        previlagesall: state.user.previlagesall,
        accessmodules: state.user.accessmodules,
        accessmodulestime: state.user.accessmodulestime
      }
  },
  dispatch => bindActionCreators({
        actionGetPrevilages: ActionGetPrevilages,
        actionGet: ActionGet,
        actionEdit: ActionEdit,
  }, dispatch),
)(Page);